import { createContext } from "react";

export interface TableContextValue {
  scrollStatus: "left" | "right" | "scrolling" | "no-scroll";
  columnsWidths: number[];
}
export const TableContext = createContext<TableContextValue>({
  scrollStatus: "left",
  columnsWidths: [],
});
